<template>
  <div>
    <div class="list-input-wrapper">
      <input :readonly="!typeable"
        class="input-list-dropdown"
        style=""
        v-model="inputValue"
        :placeholder="placeholder"
        @click="isListOpen = !isListOpen" >
      <div class="cursor-wrapper">
        <i v-if="!isListOpen" class="icon fa fa-chevron-down" @click="isListOpen = true"></i>
        <i v-else class="icon fa fa-chevron-up" @click="isListOpen = false"></i>
      </div>
    </div>
    <ul v-if="isListOpen" class="list-wrapper">
      <li v-for="(option, index) in options" :key="index"
        class="list-option"
        :style="index !== 0 ? 'border-top: 1px solid #ced4da; text-align: left;' : 'text-align: left;'"
        @click="inputValue = option;isListOpen = false">
        <img class="img-round" v-if="index <= image.length" :src="require(`./../../assets/static/images/logo/bank/square/${image[index]}`)" height="50" width="50"> {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'listDropdown',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    image: {
      type: Array,
      default: ''
    },
    options: {
      type: Array,
      default: function () {
        return []
      }
    },
    typeable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.isListOpen = true
      }
    }
  },
  data: function () {
    return {
      isListOpen: false
    }
  },
  created () {
  }
}
</script>

<style>
.list-input-wrapper {
  display: flex;
  border: 1px solid;
  border-color: #ced4da;
}
.input-list-dropdown {
  border: 0;
  width: fill-available;
  padding: 10px 10px 10px 10px;
}

.cursor-wrapper {
  position: relative;
  align-items: left;
  width: 4em;
  padding: 0 1em 0 1em;
}
.cursor-wrapper > i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.list-wrapper {
  list-style-type: none;
  padding: 0;
  border-left: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid;
  border-color: #ced4da;
}

.list-option {
  list-style: none;
  padding: 10px 10px 10px 10px;
}

.img-round {
  border-radius: 0%;
}
</style>
